// Utility functions for text processing

/**
 * Strip HTML tags from text
 */
export function stripHtml(html: string): string {
  if (!html) return '';
  
  // Create a temporary div element
  const tmp = document.createElement('div');
  tmp.innerHTML = html;
  
  // Get text content (automatically strips HTML)
  return tmp.textContent || tmp.innerText || '';
}

/**
 * Decode HTML entities
 */
export function decodeHtmlEntities(text: string): string {
  if (!text) return '';
  
  const txt = document.createElement('textarea');
  txt.innerHTML = text;
  return txt.value;
}

/**
 * Clean text: strip HTML and decode entities
 */
export function cleanText(text: string): string {
  if (!text) return '';
  return decodeHtmlEntities(stripHtml(text));
}
